import { byLang, type MdModule } from '../byLang';

export const contents = byLang(import.meta.glob<MdModule>('./*/*.md'));
